module.exports = __webpack_public_path__ + "static/media/IMG_8459_up_rsz.930f30f0.jpg";